// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1nWpt","title":"InfoRow_title__34pFh"};